// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","green":"Button_green__BmEGH","secondary":"Button_secondary__sUGsj"};